import React, { useContext, useState } from "react";
import "./singleEleve.scss";

import { Close } from "@mui/icons-material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
// import imageAvatar from "../../../assets/images/studentpp.png";
import { EleveType, requestType } from "../../../types/GlobalType";
import { eleveContext, parentContext } from "../../../context/AppContext";
import moment from "moment";
import { URL_BACKEND_APP } from "../../../App.constants";
import axios from "axios";
import { catchErrorApiCall } from "../../../_services/apiUtils";
import { accountService } from "../../../_services/accountServices";
import FileResizer from "react-image-file-resizer";
import toast, { LoaderIcon } from "react-hot-toast";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<Boolean>>;
  setReload: React.Dispatch<React.SetStateAction<number>>;
}

const SingleEleve = (props: Props) => {
  // const dd = useContext(eleveContext);

  const navigate = useNavigate();

  const handleNavidate1 = () => {
    navigate("");
  };

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: null,
  });

  const handleNavidate2 = () => {
    navigate("parent-info");
  };

  const location = useLocation();
  let currentRoute: string = location.pathname.split("/")[2];

  const eleveData: EleveType = useContext(eleveContext);

  //UPLOAD FILE
  const [file, setfile] = useState<File | null>(null);
  const [base64Image, setBase64Image] = useState(null);

  const handleChangeFile = (event: any) => {
    const file = event.target.files[0];

    if (file) {
      setfile(file);
      //Resize the image file
      FileResizer.imageFileResizer(
        file,
        500, // max width
        500, // max height
        "JPEG", // output format
        100, // quality
        0, // rotation
        (uri: any) => {
          setBase64Image(uri); // Set the resized image to state
        },
        "base64", // Output type
        500, // max width
        500,
      );
    }
  };

  const handleUploadImage = async () => {
    let token = accountService.getToken();

    if (!token) {
      accountService.logout();
      return navigate("/login");
    }

    if (!base64Image) return;

    setState({
      isLoading: true,
      errorMessage: null,
    });

    //blow method convert the base60 into forData
    const blob = await (await fetch(base64Image)).blob();
    const formData = new FormData();
    formData.append("image", blob, "resized-image.png");

    let url = `${URL_BACKEND_APP}/eleve/uploadImage.php?id=${eleveData.eleve_id}`;

    try {
      const response = await axios.post(
        url,
        formData,

        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + token,
          },
        },
      );
      // console.log("Image saved successfully====>", response.data);
      setState({
        isLoading: false,
        errorMessage: null,
      });

      toast.success("Mise à jour de l'image effectuée avec succès", {
        style: {
          backgroundColor: "#20aa1b", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      props.setReload((prev) => prev + 1);
      props.setOpen(false);
      // reloadComponent();
    } catch (error: any) {
      // console.log("Errorr====>", error);

      setState({
        isLoading: false,
        errorMessage: "Vérifier votre connexion et actualiser",
      });

      // setfile(undefined);

      catchErrorApiCall(error);

      if (error.response) {
        if (error.response.status === 403) {
          localStorage.clear();
          return navigate("/login");
        }
        if (error.response.status === 405) {
          localStorage.clear();
          return navigate("/login");
        }
      }
    }
  };

  let defaultSrc =
    "https://cdn.pixabay.com/photo/2017/01/10/03/54/avatar-1968236_1280.png";

  let img_name;
  if (eleveData.path_img) {
    img_name = eleveData.path_img.split("/").pop();
  }
  let img_url = `${URL_BACKEND_APP}/public/img/eleve/${img_name}`;

  const [imageSrc, setImageSrc] = useState(defaultSrc);

  const handleImageLoad = () => {
    setImageSrc(img_url);
  };

  const handleImageError = () => {
    setImageSrc(defaultSrc);
  };

  React.useEffect(() => {
    navigate("");
  }, []);

  return (
    <div className="UpdateEleve">
      <div className="dialog">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <span>Profile Elève</span>
            </div>
            <div className="right_">
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </div>
          </div>
        </div>

        <div className="body">
          <div className="avatar_info">
            <div className="img_container">
              {base64Image !== null ? (
                <img src={base64Image} alt="" />
              ) : !eleveData.path_img ? (
                <img src={defaultSrc} alt="" />
              ) : (
                <img
                  src={imageSrc}
                  onLoad={img_url !== imageSrc ? handleImageLoad : undefined}
                  onError={handleImageError}
                  alt="imgP"
                  style={{ objectFit: "cover" }}
                />
              )}

              <div className="names">
                <h3>{`${eleveData.nom?.toUpperCase()} ${eleveData.postnom?.toUpperCase()} ${eleveData.prenom?.toUpperCase()}`}</h3>
                <span>
                  {`${eleveData.classe_designation?.toUpperCase()}, Age ${moment().diff(
                    eleveData.date_naissance,
                    "years",
                  )} ans, Genre: ${eleveData.sexe} `}
                </span>
                <div className="updateProfil">
                  <label htmlFor="imageP"> Modifier photo de profil</label>
                  <input
                    type="file"
                    hidden
                    id="imageP"
                    onChange={handleChangeFile}
                    accept="image/png, image/jpeg"
                  />

                  {!!file && (
                    <div className="validateBtn">
                      {state.isLoading ? (
                        <>
                          <LoaderIcon />
                          <span>En cours...</span>
                        </>
                      ) : (
                        <>
                          <button
                            onClick={() => {
                              setBase64Image(null);
                              setfile(null);
                            }}
                          >
                            Annuler
                          </button>
                          <button onClick={handleUploadImage}>Ajouter</button>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="btns">
              {eleveData.eleve_status ? (
                <button>Actif</button>
              ) : (
                <button>Non actif</button>
              )}
            </div> */}
          </div>
          <div className="links">
            <span onClick={handleNavidate1}>
              Appercu
              <div
                className={currentRoute === undefined ? "underline1" : ""}
              ></div>
            </span>

            <span onClick={handleNavidate2}>
              Tuteur
              <div
                className={currentRoute === "parent-info" ? "underline2" : ""}
              ></div>
            </span>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SingleEleve;
